import Link from "next/link";
import { Stack } from "@mui/material";
import { MdInfoOutline } from "react-icons/md";

import { routes } from "src/shared/routes";

import { SSText } from "src/components/base/components/SSText";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Register Your Pass",
    description:
      "Register your Cyclone Mobile Pass to link your accounts with other Pass purchasers & get access to Guest Tickets! You must use the same email address you purchased your Cyclone Mobile Pass with to register, group formation for the upcoming game closes at 5PM Tuesday the week of the game.",
    authRedirectPage: routes.my_group,
    buttonLabel: "Register",
  },
  {
    title: "Guest Tickets",
    description:
      "Don't let friends miss out on the action - purchase guest tickets to bring them along to the game! Tickets are subject to availability & close 12PM Tuesday the week of the game.",
    authRedirectPage: routes.home,
    buttonLabel: "View Available Offers",
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "What games are a part of my pass?",
    answer: "All games a part of your pass are on your Upcoming Events tab.",
  },
  {
    question: "How are tickets sent to me?",
    answer: (
      <>
        You will receive a text message the day before the game with a link to
        manage your tickets in your Iowa State{" "}
        <Link href="https://am.ticketmaster.com/isu/" target="_blank">
          Account Manager
        </Link>
        .
      </>
    ),
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "Absolutely! Guest Tickets are available for all games this season. Sales for Guest Tickets close at 12PM on Tuesday the week of the game.",
  },
  {
    question: "Can I link my seats with friends",
    answer: (
      <>
        Yes! Navigate to the{" "}
        <Link
          href={{
            pathname: routes.my_group,
            query: { teamSchema: "iowastate_cyclones" },
          }}
        >
          My Group
        </Link>{" "}
        tab and create a unique link to share with your friends. You will all be
        seated close together during the game. Group formation for the upcoming
        game closes at 5PM on Tuesday the week of the game.
      </>
    ),
  },
  {
    question: "Can my tickets be transferred to a friend?",
    answer:
      "Your tickets are non-transferable and not eligible for resale. Abusing these guidelines can result in your pass being revoked.",
  },
  {
    question: "How can I get a refund for my tickets?",
    answer: (
      <>
        Passes are non-refundable. For further questions, please contact{" "}
        <Link href="mailto:tickets@iastate.edu">tickets@iastate.edu</Link>.
      </>
    ),
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);

export const ADD_ON_PURCHASE_SUCCESS_MESSAGE = {
  TITLE: () => <>You&apos;re all set to experience the action!</>,
  DESCRIPTION: () => (
    <>
      View your tickets{" "}
      <b>
        <u>
          <Link
            target="_blank"
            style={{
              color: "white",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            href="https://am.ticketmaster.com/isu/"
          >
            here
          </Link>
        </u>
      </b>
      .
    </>
  ),
};

export const SWAF_INFO_TEXT = () => (
  <Stack
    p={1}
    my={2}
    gap={1}
    borderRadius={2}
    bgcolor="#CEE8F0"
    alignItems="center"
    flexDirection="row"
    flexWrap="nowrap"
  >
    <MdInfoOutline
      color="#014361"
      style={{
        flexShrink: 0,
        fontSize: 22,
        minWidth: 24,
        minHeight: 24,
      }}
    />
    <SSText
      variant="body2"
      color="#014361"
      sx={{
        wordBreak: "break-word",
        fontSize: { xs: "1rem", sm: "1rem" },
        lineHeight: 1.4,
        fontWeight: 400,
        display: "inline",
      }}
    >
      Group formation closes Tuesday at 5PM the week prior to a game. Any groups
      formed after that time will not be accounted for in your seat assignment.
    </SSText>
  </Stack>
);
